<template>
  <div class="app-casino-game-window">
    <header v-if="!isMobile">
      <div class="info">
        <Logo/>
      </div>
      <div class="balance">
        <div class="info" v-if="user">
          Bakiye: <b> {{ user.balance }} {{ user.currency }}  </b>
        </div>
        <router-link :to="{ name: 'User', params: { section: 'deposit', payment: null } }" class="button primary">Para Yatır</router-link>
        <a href="javascript:;" @click="closeGame()" class="close">
          <svg xmlns="http://www.w3.org/2000/svg" height="329pt" viewBox="0 0 329.26933 329" width="329pt"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
        </a>
      </div>
    </header>
    <div class="game-container">
      <Loader class="slot-loader" v-if="loader">
        <template slot="text">
          <div class="loader-text">{{ text }} <span class="one">.</span><span class="two">.</span><span class="three">.</span></div>
        </template>
      </Loader>
      <div class="game" :class="{ 'fullscreen' : fullscreen }" style="position: relative; width: 1280px; height: 720px;" v-show="!loader" v-if="game_url">
        <div v-if="game_url.config.is_script" v-html-js="{html: game_url.data, script:'javascript'}"></div>
        <iframe allow="autoplay *; screen-wake-lock *; fullscreen *" allowfullscreen v-if="!game_url.config.is_script" :src="game_url.config.url" style="height:1000px" frameborder="0" width="100%"/>
        <WindowOptions/>
        <div class="fullscreen-toggle" @click="fullscreen = false" v-if="fullscreen">
          Tam Ekrandan Çık
        </div>
      </div>
    </div>
  </div>
</template> 

<script>
  import WindowOptions from './WindowOptions'
  import { mapActions } from 'vuex'
  import Logo from '../Common/Header/Logo'
  export default{
    data(){
      return{
        loader: true,
        fullscreen: false,
        text: 'Oyun Yükleniyor',
      }
    },
    components:{
      WindowOptions,
      Logo,
    },
    methods:{
      ...mapActions("slot", ["closeGame"]),
    },
    watch:{
      fullscreen(val){
        if(val){
          document.querySelector("#app").classList.add('lock');
        }else{
          document.querySelector("#app").classList.remove('lock');
        }
      },
      game_url(){
        if(!_.isNull(this.game_url)){
           this.loader = false;
        }
      }
    },
    computed:{
      favorites(){
        return this.$store.getters['slot/getFavorites'];
      },
      game_id(){
        return this.$route.query.game_id
      },
      mobile(){
        return this.$route.query.mobile
      },
      game_url(){
        return this.$store.getters['slot/getGameUrl'];
      },
      user(){
        return this.$user();
      }
    }
  }
</script>



<style lang="scss">
  .slot-loader{
    .one {
        opacity: 0;
        -webkit-animation: dot 1.3s infinite;
        -webkit-animation-delay: 0.0s;
        animation: dot 1.3s infinite;
        animation-delay: 0.0s;
    }

    .two {
        opacity: 0;
        -webkit-animation: dot 1.3s infinite;
        -webkit-animation-delay: 0.2s;
        animation: dot 1.3s infinite;
        animation-delay: 0.2s;
    }

    .three {
        opacity: 0;
        -webkit-animation: dot 1.3s infinite;
        -webkit-animation-delay: 0.3s;
        animation: dot 1.3s infinite;
        animation-delay: 0.3s;
    }
  }

  @-webkit-keyframes dot {
      0% {
          opacity: 0;
      }
      50% {
          opacity: 0;
      }
      100% {
          opacity: 1;
      }
  }

  @keyframes dot {
      0% {
          opacity: 0;
      }
      50% {
          opacity: 0;
      }
      100% {
          opacity: 1;
      }
  }
</style>
